<template>
  <div>
    <!-- HERO SECTION -->
    <header class="header">
      <home-carouzel></home-carouzel>
      <!-- <div class="availability">
        <v-availability-box />
      </div> -->
    </header>

    <!-- WELCOME SECTION -->
    <section class="section">
      <div class="container">
        <div class="welcome">
          <home-text-box></home-text-box>
          <home-pics-compo></home-pics-compo>
        </div>
      </div>
    </section>

    <!-- WHYUS SECTION -->
    <section class="section whyus">
      <div class="container wus">
        <v-heading-section>
          <template #heading-title>{{ $t('pageHome.whyus.title') }}</template>

          <template #heading-description>{{ $t('pageHome.whyus.description') }}</template>
        </v-heading-section>
        <home-cards-icon></home-cards-icon>
      </div>
    </section>

    <!-- DELUXE ROOM SECTION -->
    <section class="room section">
      <room-home :mainImg="deluxeRoom.main_img">
        <template #room-title>{{ $t('pageHome.roomRodia.title') }}</template>

        <template #room-cta>
          <room-CTA link="/rodia">
            <!-- <template v-slot:room-price>100</template> -->
          </room-CTA>
        </template>
        <!-- eslint-disable-next-line prettier/prettier -->

        <template #room-description>{{ $t('pageHome.roomRodia.description') }}</template>

        <template #room-info>
          <room-info>
            <template #info-people>{{ $t('pageHome.roomRodia.people') }}</template>

            <template #info-sqr>{{ $t('pageHome.roomRodia.sqr') }}</template>

            <template #info-bed>{{ $t('pageHome.roomRodia.bed') }}</template>

            <template #info-couch>{{ $t('pageHome.roomRodia.couch') }}</template>

            <template #info-apart>{{ $t('pageHome.roomRodia.apart') }}</template>
          </room-info>
        </template>

        <template #room-list>
          <room-list :benefitsArr="deluxeRoom.benefits" columns="2"></room-list>
        </template>

        <template #room-gallery>
          <!-- eslint-disable-next-line prettier/prettier -->
          <room-gallery :images="deluxeRoom.images" @selectImg="galleryImageDeluxe"></room-gallery>
        </template>
      </room-home>
    </section>

    <!-- STANDARD ROOM SECTION -->
    <section class="room section">
      <room-home :mainImg="standardRoom.main_img">
        <template #room-title>{{ $t('pageHome.roomElia.title') }}</template>

        <template #room-cta>
          <room-CTA link="/elia">
            <!-- <template v-slot:room-price>100</template> -->
          </room-CTA>
        </template>
        <!-- eslint-disable-next-line prettier/prettier -->

        <template #room-description>{{ $t('pageHome.roomElia.description') }}</template>

        <template #room-info>
          <room-info>
            <template #info-people>{{ $t('pageHome.roomElia.people') }}</template>

            <template #info-sqr>{{ $t('pageHome.roomElia.sqr') }}</template>

            <template #info-bed>{{ $t('pageHome.roomElia.bed') }}</template>

            <template #info-couch>{{ $t('pageHome.roomElia.couch') }}</template>

            <template #info-apart>{{ $t('pageHome.roomElia.apart') }}</template>
          </room-info>
        </template>

        <template #room-list>
          <room-list :benefitsArr="standardRoom.benefits" columns="2"></room-list>
        </template>

        <template #room-gallery>
          <!-- eslint-disable-next-line prettier/prettier -->
          <room-gallery :images="standardRoom.images" @selectImg="galleryImage"></room-gallery>
        </template>
      </room-home>
    </section>

    <!-- Mirtia ROOM SECTION -->
    <section class="room section">
      <room-home :mainImg="mirtiaRoom.main_img">
        <template #room-title>{{ $t('pageHome.roomMirtia.title') }}</template>

        <template #room-cta>
          <room-CTA link="/myrtia">
            <!-- <template v-slot:room-price>100</template> -->
          </room-CTA>
        </template>
        <template #room-description>{{ $t('pageHome.roomMirtia.description') }}</template>

        <template #room-info>
          <room-info>
            <template #info-people>{{ $t('pageHome.roomMirtia.people') }}</template>

            <template #info-sqr>{{ $t('pageHome.roomMirtia.sqr') }}</template>

            <template #info-bed>{{ $t('pageHome.roomMirtia.bed') }}</template>

            <template #info-couch>{{ $t('pageHome.roomMirtia.couch') }}</template>

            <template #info-apart>{{ $t('pageHome.roomMirtia.apart') }}</template>
          </room-info>
        </template>

        <template #room-list>
          <room-list :benefitsArr="mirtiaRoom.benefits" columns="2"></room-list>
        </template>

        <template #room-gallery>
          <!-- eslint-disable-next-line prettier/prettier -->
          <room-gallery :images="mirtiaRoom.images" @selectImg="galleryImageMirtia"></room-gallery>
        </template>
      </room-home>
    </section>

    <!-- THINGS TO SEE SECTION -->
    <section class="section things-to-see">
      <v-heading-section>
        <template #heading-title>{{ $t('pageHome.thingsToSee.title') }}</template>
        <!-- eslint-disable-next-line prettier/prettier -->

        <template #heading-description>{{ $t('pageHome.thingsToSee.description') }}</template>
      </v-heading-section>
      <wrapper-skewbg :bgURL="thingsToSee.background" :isSkewed="false">
        <card-flipper v-for="(feature, idx) in thingsToSee.features" :key="idx">
          <template #front-card>
            <card-image :image="feature.img" :imageAlt="feature.alt">
              <template #card-description>{{ feature.desc }}</template>

              <template #card-distance>{{ feature.dist }}</template>
            </card-image>
          </template>

          <template #back-card>
            <card-image>
              <template #card-info>
                {{ feature.info }}
              </template>

              <template #card-description>{{ feature.desc }}</template>

              <template #card-distance>{{ feature.dist }}</template>
            </card-image>
          </template>
        </card-flipper>
      </wrapper-skewbg>
    </section>

    <!-- TESTIMONIALS SECTION -->
    <section class="section testimonials">
      <v-heading-section>
        <template #heading-title>{{ $t('pageHome.testimonials.title') }}</template>
      </v-heading-section>
      <!-- eslint-disable-next-line prettier/prettier -->
      <wrapper-skewbg :bgURL="whyus.background" :isSkewed="false">
        <!-- eslint-disable-next-line prettier/prettier -->
        <card-testimonial v-for="(card, idx) in testimonials.cards" :key="idx" :stars="card.stars">
          <template #testimonial-title>{{ card.title }}</template>

          <template #testimonial-text>{{ card.text }}</template>

          <template #testimonial-name>{{ card.name }}</template>

          <template #testimonial-date>{{ card.date }}</template>
        </card-testimonial>
      </wrapper-skewbg>
    </section>
  </div>
</template>

<script>
import HomeCarouzel from '@/components/layout/HomeCarouzel.vue';
import HomeTextBox from '@/components/layout/HomeTextBox.vue';
import HomeCardsIcon from '@/components/layout/HomeCardsIcon.vue';

// Layout
import WrapperSkewbg from '@/components/atomic/WrapperSkewbg.vue';
import RoomHome from '@/components/atomic/WrapperRoom.vue';
import CardFlipper from '@/components/atomic/WrapperCardFlipper.vue';
// Partials

// import VAvailabilityBox from '@/components/modules/VAvailabilityBox.vue';
import HomePicsCompo from '@/components/layout/HomePicsCompo.vue';
import VHeadingSection from '@/components/atomic/VHeadingSection.vue';
import RoomInfo from '@/components/atomic/RoomInfo';
import RoomList from '@/components/atomic/RoomList';
import RoomGallery from '@/components/atomic/RoomGallery';
import RoomCTA from '@/components/modules/RoomCTA';
// Cards
// import VCardIcon from '@/components/atomic/VCardIcon.vue';
import CardImage from '@/components/atomic/CardImage.vue';
import CardTestimonial from '@/components/atomic/CardTestimonial.vue';

export default {
  name: 'Home',
  components: {
    HomeCarouzel,
    HomeTextBox,
    VHeadingSection,
    // VAvailabilityBox,
    // VCardIcon,
    WrapperSkewbg,
    RoomHome,
    RoomInfo,
    RoomList,
    RoomGallery,
    RoomCTA,
    CardImage,
    CardTestimonial,
    CardFlipper,
    HomePicsCompo,
    HomeCardsIcon,
  },
  data() {
    return {
      lightbox: false,
      lightboxIdx: 0,

      whyus: {
        description: 'Οι πιο δημοφιλείς παροχές που για τις οποίες μας προτιμάνε οι πελάτες μας',
        background:
          'https://images.unsplash.com/photo-1574266865529-6fbac1841ee9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80',
        features: [
          {
            id: 1,
            icon: 'fas fa-wifi',
            text: 'Wi-Fi διατίθεται σε όλους τους χώρους και δεν χρεώνεται',
            title: 'Wi-Fi Internet.',
          },
          {
            id: 2,
            icon: 'fas fa-hamburger',
            // eslint-disable-next-line prettier/prettier
            text: 'Κιόσκι με εγκαταστάσεις BBQ για αξέχαστες οικογενιακές και όχι μόνο στιγμές.',
            title: 'Εγκαταστασεις BBQ',
          },
          {
            id: 3,
            icon: 'fas fa-parking',
            // eslint-disable-next-line prettier/prettier
            text: 'Xώρος στάθμευσης στο χώρο του ξενοδοχείου, δεν απαιτείται κράτηση.',
            title: 'χωρος σταθμευσης',
          },
          {
            id: 4,
            icon: 'fas fa-seedling',
            text: '',
            title: 'Βεραντα και Κηπος',
          },
        ],
      },

      deluxeRoom: {
        main_img: {
          // eslint-disable-next-line prettier/prettier
          url:
            'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1597072325/rodia-room/rizes-house_rodia-room_7_bfghky.jpg',
          alt: 'rizes-house rodia-room',
        },

        description: this.$t('aboutus.title'),
        benefits: [
          this.$t('pageHome.roomRodia.benefits.1'),
          this.$t('pageHome.roomRodia.benefits.2'),
          this.$t('pageHome.roomRodia.benefits.3'),
          this.$t('pageHome.roomRodia.benefits.4'),
          this.$t('pageHome.roomRodia.benefits.5'),
          this.$t('pageHome.roomRodia.benefits.6'),
          this.$t('pageHome.roomRodia.benefits.7'),
          this.$t('pageHome.roomRodia.benefits.8'),
          this.$t('pageHome.roomRodia.benefits.9'),
          this.$t('pageHome.roomRodia.benefits.10'),
          this.$t('pageHome.roomRodia.benefits.11'),
          this.$t('pageHome.roomRodia.benefits.12'),
        ],
        images: [
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1597072327/rodia-room/rizes-house_rodia-room_4_q4s2d2.jpg',
            alt: 'rizes-house rodia-room',
          },
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1597072329/rodia-room/rizes-house_rodia-room_1_eq14jy.jpg',
            alt: 'rizes-house rodia-room',
          },
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1597072326/rodia-room/rizes-house_rodia-room_8_mvuyru.jpg',
            alt: 'rizes-house rodia-room',
          },
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1597072328/rodia-room/rizes-house_rodia-room_14_h73vxq.jpg',
            alt: 'rizes-house rodia-room',
          },
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1597072330/rodia-room/rizes-house_rodia-room_10_azlfjr.jpg',
            alt: 'rizes-house rodia-room',
          },
        ],
      },
      standardRoom: {
        main_img: {
          // eslint-disable-next-line prettier/prettier
          url:
            'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1597072224/elia-room/rizes-house_elia-room_6_qhpfvj.jpg',
          alt: 'rizes-house elia-room',
        },

        description:
          'Διακόσμηση με εξαιρετικό γούστο, άνεση και πολυτέλεια χαρακτηρίζουν αυτό το διαμέρισμα. Διαθέτει δύο υπνοδωμάτια με υπέρδιπλα κρεβάτια, καλοκουζίνα και μπάνιο. Περιλαμβάνει πλήρως εξοπλισμένη κουζίνα, τρία κλιματιστικά και πλυντήριο ρούχων. Κάθε χώρος έχει το δικό του μπαλκόνι με θέα.',
        benefits: [
          this.$t('pageHome.roomElia.benefits.1'),
          this.$t('pageHome.roomElia.benefits.2'),
          this.$t('pageHome.roomElia.benefits.3'),
          this.$t('pageHome.roomElia.benefits.4'),
          this.$t('pageHome.roomElia.benefits.5'),
          this.$t('pageHome.roomElia.benefits.6'),
          this.$t('pageHome.roomElia.benefits.7'),
          this.$t('pageHome.roomElia.benefits.8'),
          this.$t('pageHome.roomElia.benefits.9'),
          this.$t('pageHome.roomElia.benefits.10'),
        ],
        images: [
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1597072224/elia-room/rizes-house_elia-room_8_jqnskg.jpg',
            alt: 'rizes-house elia-room',
          },
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1597072224/elia-room/rizes-house_elia-room_11_ok4ibp.jpg',
            alt: 'rizes-house elia-room',
          },
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1597072220/elia-room/rizes-house_elia-room_2_kwtexe.jpg',
            alt: 'rizes-house elia-room',
          },
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1597072219/elia-room/rizes-house_elia-room_7_b3jzji.jpg',
            alt: 'rizes-house elia-room',
          },
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1597072219/elia-room/rizes-house_elia-room_5_nu6tk3.jpg',
            alt: 'rizes-house elia-room',
          },
        ],
      },

      mirtiaRoom: {
        main_img: {
          // eslint-disable-next-line prettier/prettier
          url:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1709743703/Mirtia/xlqzd4qatjar0wwg0gbw.jpg',
          alt: 'rizes-house mirtia-room',
        },
        description: this.$t('aboutus.title'),
        benefits: [
          this.$t('pageHome.roomMirtia.benefits.1'),
          this.$t('pageHome.roomMirtia.benefits.2'),
          this.$t('pageHome.roomMirtia.benefits.3'),
          this.$t('pageHome.roomMirtia.benefits.4'),
          this.$t('pageHome.roomMirtia.benefits.5'),
          this.$t('pageHome.roomMirtia.benefits.6'),
          this.$t('pageHome.roomMirtia.benefits.7'),
          this.$t('pageHome.roomMirtia.benefits.8'),
          this.$t('pageHome.roomMirtia.benefits.9'),
          this.$t('pageHome.roomMirtia.benefits.11'),
          this.$t('pageHome.roomMirtia.benefits.12'),
        ],
        images: [
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1709743704/Mirtia/n2wqf3lw5gkbh3hkk692.jpg',
            alt: 'rizes-house mirtia-room',
          },
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1709743705/Mirtia/d70sljj98wxdgporitfe.png',
            alt: 'rizes-house mirtia-room',
          },
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1709743704/Mirtia/zjuwi2vl1uww8rkykseq.jpg',
            alt: 'rizes-house mirtia-room',
          },
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1709743703/Mirtia/xlqzd4qatjar0wwg0gbw.jpg',
            alt: 'rizes-house mirtia-room',
          },
          {
            // eslint-disable-next-line prettier/prettier
            url:
              'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_700/v1709743704/Mirtia/jakaz6uli8runcpzy6ws.jpg',
            alt: 'rizes-house mirtia-room',
          },
        ],
      },
      thingsToSee: {
        title: 'Αξιοθεατα που προτεινουν οι ντοπιοι',
        description:
          'Τόπος μοναδικού φυσικού κάλλους. Ένας τόπος που οι αποχρώσεις του μπλε και του πράσινου παντρεύονται σαν σε μια ζωγραφιά με θέμα τη φύση. Τα τυρκουάζ χρώματα και το πράσινο που έχει η περιοχή μαγεύουν και η επίσκεψη στο μέρος αποτελεί μια εκπληκτική εμπειρία.',
        background:
          'https://images.unsplash.com/photo-1515016454727-48ddf26ac789?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
        features: [
          {
            id: 1,
            // eslint-disable-next-line prettier/prettier
            img:
              'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,h_266,q_auto:best,w_400/v1597062059/locations/lagonisi.jpg',
            alt: 'lagonisi halchidiki',
            desc: this.$t('pageHome.thingsToSee.features.1.desc'),
            dist: '2.1 χλμ.',
            // eslint-disable-next-line prettier/prettier
            info: this.$t('pageHome.thingsToSee.features.1.info'),
          },
          {
            id: 2,
            // eslint-disable-next-line prettier/prettier
            img:
              'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,h_266,q_auto:best,w_400/v1597072263/locations/rizes-house_locations-agios-nikolaos_1_keyiii.jpg',
            alt: 'agios ikolaos',
            desc: this.$t('pageHome.thingsToSee.features.2.desc'),
            dist: '0.5 χλμ.',
            // eslint-disable-next-line prettier/prettier
            info: this.$t('pageHome.thingsToSee.features.2.info'),
          },
          {
            id: 3,
            // eslint-disable-next-line prettier/prettier
            img:
              'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,h_266,q_auto:best,w_400/v1597072264/locations/rizes-house_locations-libroxio_2_kxjibz.jpg',
            alt: 'beach libroxio trani ammouda',
            desc: this.$t('pageHome.thingsToSee.features.3.desc'),
            dist: '1 χλμ.',
            // eslint-disable-next-line prettier/prettier
            info: this.$t('pageHome.thingsToSee.features.3.info'),
          },
        ],
      },
      testimonials: {
        title: 'Τι λενε για μας οι πελατες μας',
        cards: [
          {
            title: 'Ένα διαμέρισμα διαμαντάκι στο γραφικό χωριό του Αγίου Νικολάου στη Σιθωνία.',
            stars: 5,
            // eslint-disable-next-line prettier/prettier
            text:
              'Πεντακάθαρο και με εξαιρετική διαρίθμηση χώρων. 3 μπαλκόνια σε διαφορετικά επίπεδα όπου ανάλογα με την ώρα της ημέρας μπορεί κάποιος να απολαύσει τη γαλήνη της περιοχής. Στο σπίτι υπάρχουν όλες οι ανέσεις που μπορεί κάποιος να ζητήσει και μια υπέροχη διακόσμηση που πλαισιώνεται από καθαριότητα και ευγένεια. Πραγματικά αισθάνεσαι σαν το σπίτι σου!!',
            name: 'Eleni Kalaitzidou',
            location: '',
            date: 'August 20, 2018',
          },
          {
            title: 'Μείναμε 3 βραδιά και περάσαμε υπέροχα!!!',
            stars: 5,
            // eslint-disable-next-line prettier/prettier
            text:
              'Το χωριό είναι πολύ γραφικό με μικρά μαγαζάκια, η θάλασσα είναι 5 λεπτά με το αμαξι(από τις πιο ωραίες της Χαλκιδικής) . Μεγάλοι χώροι πολύ όμορφα διακοσμημένοι, με όλες τις ανέσεις και πάνω από όλα πεντακάθαρα!!! Διαθέτει και αυλή με κήπο!!! Τα κορίτσια μας βοήθησαν σε όλα ήταν πολύ εξυπηρετικές!!! Σίγουρα θα ξανά πάμε, το συστήνουμε ανεπιφύλακτα!!!!',
            name: 'Μαρια',
            location: '',
            date: 'June 10, 2020',
          },
          {
            title: 'Τέλεια διαμερίσματα!!!',
            // eslint-disable-next-line prettier/prettier
            text:
              'Πήγαμε παρέα και μείναμε όλοι πολύ ευχαριστημένοι! Πεντακάθαρα και καλαίσθητα...και τα στρώματα Ιδανικά για ποιοτικό ύπνο! Οι φωτογραφίες το αδικούν λίγο. Από κοντά είναι πολύ πιο όμορφα! Η τοποθεσία εξαιρετική.συνδυάζει το παραδοσιακό του χωριού σε πολύ κοντινή απόσταση από τη θάλασσα!Και φυσικά οι ιδιοκτήτες πολύ ευγενικοί και εξυπηρετικοί..θα το επιλέξουμε σίγουρα όταν ξανά πάμε Χαλκιδική!!!',
            stars: 5,

            name: 'Aggeliki',
            date: 'June 16, 2020',
          },
        ],
      },
    };
  },
  methods: {
    galleryImage(value) {
      this.standardRoom.main_img = value;
    },
    galleryImageDeluxe(value) {
      this.deluxeRoom.main_img = value;
    },
    galleryImageMirtia(value) {
      this.mirtiaRoom.main_img = value;
    },
    imageClicked(idx) {
      this.lightbox = true;
      this.lightboxIdx = idx;
    },
  },
};
</script>

<style lang="scss" scoped>
/***** HERO SECTION *****/

/***** WELCOME SECTION ******/
.welcome {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;

  min-height: 500px;
}

/***** WHYUS SECTION *****/

.whyus {
  flex-direction: column;
  gap: 12px;
}

.wus {
  background-color: hsl(var(--clr-primary-500));
  display: flex;
  align-items: center;
  justify-content: center;
}

/***** TESTIMONIALS SECTION *****/

/***** MEDIA QUERIES *****/
@media (max-width: 600px) {
  .welcome {
    margin-top: 32px;
  }

  .next-cards {
    width: 95%;
  }
}
</style>
